import { styled, tableContainerClasses } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
/**
 * Wraps a {@link Table} inside a fixed block with borders and scroller.
 *
 * Main goal of this Wrapper is to hide scroller's keen edges that go beyond the boundaries of a {@link TableContainer}.
 *
 * Should be used inside {@link Dialog} as a parent of {@link TableContainer}.
 */
export const DialogTableContainerWrapper = styled('div', shouldNotForwardProps('height', 'expand', 'invalid'))(({ theme, height, expand, invalid }) => ({
    overflow: 'hidden',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.neutral.light,
    borderRadius: `var(--gp-radius-lg)`,
    [`.${tableContainerClasses.root}`]: {
        height: height,
        maxHeight: height,
    },
    ...(expand && {
        display: 'flex',
        flex: 1,
    }),
    ...(invalid && {
        borderColor: theme.palette.error.main,
    }),
    ...theme.applyStyles('dark', {
        borderColor: theme.palette.zinc[600],
        ...(invalid && {
            borderColor: theme.palette.error.main,
        }),
    }),
}));
